import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { classNames } from 'utils/functions';

export default function SidebarItem({
  path,
  index,
  max,
  isChild,
  children,
  onClick,
}: {
  path: string;
  index: number;
  max: number;
  isChild?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
}) {
  const location = useLocation();

  return (
    <Link
      to={path}
      className={classNames(
        location.pathname === path
          ? 'border-l-8 bg-gray-100 text-gray-900'
          : 'text-gray-600 hover:border-l-8 hover:bg-gray-50 hover:text-gray-900 focus:border-l-8 focus:bg-gray-50 focus:text-gray-900',
        isChild ? 'ml-6' : 'rounded-md',
        index === 0 ? 'rounded-t-md' : '',
        index === max ? 'rounded-b-md' : '',
        'group flex items-center border-primary-600 py-2 px-2 text-sm font-medium transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-100'
      )}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}
